<script setup lang="ts">
  // TODO keepalive in all pages
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition
      name="fade"
      mode="out-in">
      <keep-alive include="page-home,page-list">
        <component :is="Component" />
      </keep-alive>
    </transition>
  </router-view>
</template>
